import React from 'react';
import { Box, Button, Chip, Stack, Tooltip, Typography } from '@mui/material';
import AutoFixHighOutlinedIcon from '@mui/icons-material/AutoFixHighOutlined';

interface EnrichCTAProps {
  count: number;
}

// CTA strip shown above the "Без перекладу" sub-tab. Until Gemini-batch
// enrichment (B.2) lands the button is disabled with a "скоро" pill — the
// affordance is visible so users know the dead-end will be fixed, but they
// can't fire requests against an unimplemented endpoint.
const EnrichCTA: React.FC<EnrichCTAProps> = ({ count }) => (
  <Box
    sx={(theme) => ({
      bgcolor:
        theme.palette.mode === 'dark'
          ? 'rgba(226, 166, 16, 0.08)'
          : 'rgba(226, 166, 16, 0.10)',
      border: `1px solid ${
        theme.palette.mode === 'dark'
          ? 'rgba(226, 166, 16, 0.25)'
          : 'rgba(226, 166, 16, 0.35)'
      }`,
      borderRadius: 2,
      px: 2,
      py: 1.5,
    })}
  >
    <Stack
      direction={{ xs: 'column', sm: 'row' }}
      alignItems={{ xs: 'flex-start', sm: 'center' }}
      justifyContent={'space-between'}
      spacing={1.25}
    >
      <Stack direction={'row'} spacing={1.5} alignItems={'center'} sx={{ minWidth: 0 }}>
        <Box
          sx={{
            alignItems: 'center',
            bgcolor: 'rgba(226, 166, 16, 0.25)',
            borderRadius: '50%',
            color: '#A87800',
            display: 'flex',
            flexShrink: 0,
            height: 36,
            justifyContent: 'center',
            width: 36,
          }}
        >
          <AutoFixHighOutlinedIcon fontSize={'small'} />
        </Box>
        <Box sx={{ minWidth: 0 }}>
          <Typography fontWeight={700}>
            {`${count} слів без перекладу`}
          </Typography>
          <Typography variant={'body2'} color={'text.secondary'}>
            {'AI підбере переклад, частину мови й коротке визначення одним батчем.'}
          </Typography>
        </Box>
      </Stack>

      <Tooltip
        arrow
        placement={'top'}
        title={'AI-збагачення зʼявиться в наступному релізі.'}
      >
        <span>
          <Button
            startIcon={<AutoFixHighOutlinedIcon />}
            disabled
            endIcon={
              <Chip
                label={'скоро'}
                size={'small'}
                sx={{
                  bgcolor: '#A87800',
                  color: '#FFF',
                  fontSize: 10,
                  fontWeight: 700,
                  height: 18,
                  '& .MuiChip-label': { px: 0.75 },
                }}
              />
            }
          >
            {'Дозбагатити через AI'}
          </Button>
        </span>
      </Tooltip>
    </Stack>
  </Box>
);

export default EnrichCTA;
